import { render, staticRenderFns } from "./addKeyWord.vue?vue&type=template&id=1279be1b&scoped=true"
import script from "./addKeyWord.vue?vue&type=script&lang=js"
export * from "./addKeyWord.vue?vue&type=script&lang=js"
import style0 from "./addKeyWord.vue?vue&type=style&index=0&id=1279be1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1279be1b",
  null
  
)

export default component.exports